<template>
  <p-create v-if="$hasPermission('users')" />
  <p-not-found v-else />
</template>

<script>
import NotFound from './../components/NotFound.vue';
import CreateUser from './../components/users/CreateUser.vue';

export default {
  components: {
    'p-create': CreateUser,
    'p-not-found': NotFound
  }
};
</script>
